import { useEffect } from 'react';

const REVEAL_SELECTOR = [
  '.section-title',
  '.stat-card',
  '.beneficio-card',
  '.plano-card',
  '.plano-plus-container',
  '.vantagem-item',
  '.galeria-item',
  '.mercado-card',
  '.diferencial-item',
  '.depoimento-card',
  '.resultado-card',
  '.membro-card',
  '.contato-info',
  '.contato-form',
  '.conquista-media',
  '.conquista-card',
  '.conquista-timeline li'
].join(', ');

export function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(REVEAL_SELECTOR);
    elements.forEach((el) => el.classList.add('reveal'));

    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('reveal-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
